import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import UpcomingMatches from "@/components/UpcomingMatches";

export default function PresidenteDashboard() {
    const { user } = useAuth();
    const team = user?.team;
    const teamId = team?.id || user?.team_id;

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="presidente-dashboard">
            <div className="op-label text-t2bb6ff">// AREA PRESIDENTE</div>
            <h1 className="op-heading text-5xl sm:text-6xl mt-3">
                CIAO, <span className="text-t2bb6ff">{user?.name?.toUpperCase()}</span>
            </h1>

            {team ? (
                <div className="op-card p-6 mt-8" data-testid="presidente-team-card">
                    <div className="op-label">// LA TUA SQUADRA</div>
                    <div className="op-heading text-4xl mt-3">{team.name}</div>
                    <div className="grid grid-cols-2 sm:grid-cols-4 mt-5 border-t border-t22252a">
                        <Stat label="Budget" value={`${(team.budget / 1000000).toLocaleString("it-IT")} mln`} />
                        <Stat label="Stadio Lv." value={team.stadium_level} />
                        <Stat label="Rosa" value="—" sub="prossima fase" />
                        <Stat label="Stipendi" value="—" sub="prossima fase" />
                    </div>
                </div>
            ) : (
                <div className="op-card p-8 mt-8 text-center" data-testid="presidente-no-team">
                    <div className="op-label">// NESSUNA SQUADRA ASSEGNATA</div>
                    <p className="text-tc9ccd3 mt-3 leading-relaxed">
                        Un admin del CDP non ti ha ancora assegnato una squadra. Riceverai
                        accesso completo non appena verrà fatto.
                    </p>
                </div>
            )}

            {/* Le mie prossime partite */}
            {teamId && <UpcomingMatches teamId={teamId} limit={10} canManage={true} />}

            <div className="op-card p-6 mt-6">
                <div className="op-label text-t2bb6ff">// PROSSIME FASI</div>
                <h3 className="op-heading text-2xl mt-3">Cosa arriverà</h3>
                <ul className="mt-3 text-tc9ccd3 text-sm space-y-2 list-disc list-inside leading-relaxed">
                    <li>Bot Telegram per notifiche di mercato e partite</li>
                    <li>Albo d'Oro automatico al termine di ogni competizione</li>
                    <li>Mercato Ugly / Primavera con promozione automatica</li>
                    <li>Offerte AI da Cina / Arabia</li>
                </ul>
                <Link to="/regolamento" className="op-btn mt-5 inline-flex" data-testid="presidente-rules-link">
                    Consulta il regolamento
                </Link>
            </div>
        </div>
    );
}

function Stat({ label, value, sub }) {
    return (
        <div className="p-5 border-r border-t22252a last:border-r-0">
            <div className="op-label">{label}</div>
            <div className="mt-2 op-mono text-2xl text-tffffff font-bold">{value}</div>
            {sub && <div className="text-t5c6370 op-mono text-[10px] mt-1">{sub}</div>}
        </div>
    );
}
